import type { ReactNode } from "react";

import { Footer } from "@/components/layout/Footer";
import { Header } from "@/components/layout/Header";
import { Picture } from "@/components/media/Picture";


/** Interior page shell: image hero with title, then content, then footer. */
export function PageShell({
  title,
  eyebrow,
  image,
  children,
}: {
  title: string;
  eyebrow?: string;
  image: string;
  children: ReactNode;
}) {
  return (
    <div className="min-h-dvh bg-background">
      <Header />
      <section aria-label={title} className="relative flex min-h-[380px] items-end">
        <Picture
          src={image}
          alt=""
          sizes="100vw"
          fetchPriority="high"
          decoding="async"
          className="absolute inset-0 h-full w-full object-cover"
        />

        <div className="hero-scrim absolute inset-0" aria-hidden />
        <div className="container-site relative pb-12 pt-28 sm:pb-14 sm:pt-32">
          {eyebrow ? <p className="eyebrow mb-3 text-sm text-white/90">{eyebrow}</p> : null}
          <h1 className="text-4xl text-white sm:text-6xl">{title}</h1>
        </div>
      </section>
      <main id="main" className="container-site max-w-3xl section-y">
        {children}
      </main>
      <Footer />
    </div>
  );
}
